<template>
    <div id="teamDetail">
        <bread :content="breadContent"></bread>
        <p class="Page-title">研究团队</p>
        <el-divider></el-divider>
        <div id="content">
            <div id="left">
                <img :src="detailData.Head">
                <p style="font-weight: bold;">个人信息</p>
                <p>职称：</p>
                <span>{{detailData.JobTitle}}</span>
                <p>职务：</p>
                <span>{{detailData.Position}}</span>
                <p>电话：</p>
                <span>{{detailData.Phone}}</span>
                <p>电子邮箱：</p>
                <span>{{detailData.Email}}</span>
                <p>通讯地址：</p>
                <span>{{detailData.Address}}</span>
                <p>邮政编码：</p>
                <span>{{detailData.PostalCode}}</span>
            </div>
            <div id="right" v-html="detailData.Content">

            </div>
        </div>
    </div>
</template>
<script>
import bread from "@/components/bread"
import Api from '@/network'

export default {
  name: "teamDetail",
  components: {
    bread
  },
  async beforeRouteEnter (to, from, next) {
    const res = await Api.introduce.getDetail(to.query.id)
    next(vm => {
      vm.$data.detailData = res
      vm.$store.commit('setHighlightText', '研究团队')
    })
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "中心概况", routerName: "introduce" },
        { text: "研究团队", routerName: "team" }
      ],
      detailData:{},
    };
  },
  destroyed() {
    this.$store.commit('setHighlightText', '')
  }
};
</script>
  
<style lang="scss" scoped>
#teamDetail {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#content {
  display: flex;
  justify-content: space-between;
}
#left {
  display: flex;
  flex-direction: column;
  width: 30%;
  img {
    width: 200px;
    height: 260px;
  }
  p{
    margin-top: 20px;
    margin-bottom: 6px;
    font-size: 24px;
  }
  span{
    font-size: 18px;
    color: #333333;
    opacity: .5;
  }
}
#right {
  width: 60%;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(215, 215, 215, 1);
  border-radius: 3px;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
  .black-div {
    width: 8px;
    height: 24px;
    background-color: rgba(0, 0, 0, 1);
    color: #000000;
    margin-right: 15px;
  }
  .title {
    display: flex;
    align-items: flex-end;
    font-size: 20px;
    font-weight: 400;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  span {
    font-size: 18px;
    line-height: 32px;
  }
}
</style>
